import { render, staticRenderFns } from "./HostingFtpTable.vue?vue&type=template&id=55714848&scoped=true"
import script from "./HostingFtpTable.vue?vue&type=script&lang=js"
export * from "./HostingFtpTable.vue?vue&type=script&lang=js"
import style0 from "./HostingFtpTable.vue?vue&type=style&index=0&id=55714848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55714848",
  null
  
)

export default component.exports